let swiper = null;

$(document).on('turbolinks:before-cache', () => {
  if (swiper) {
    swiper.destroy();
    swiper = null;
  }
});

$(document).on('turbolinks:load', async () => {
  const node = document.querySelector('article.questions');
  if (!node) { return; }

  const [{ default: Swiper }, { Pagination }] = await Promise.all([
    import('swiper'),
    import('swiper/modules')
  ]);

  swiper = new Swiper('article.questions .slides', {
    wrapperClass: 'slides-wrapper',
    slideClass: 'blue-slide',
    slidesPerView: 'auto',
    spaceBetween: 0,
    modules: [Pagination],
    pagination: {
      el: '.b-slider-pagination',
      modifierClass: 'slider-pagination-',
      bulletClass: 'slider-pagination-bullet',
      bulletActiveClass: 'slider-pagination-bullet-active',
      clickable: true
    }
  });
  swiper.changeLanguageDirection(document.documentElement.getAttribute('dir'));
});
